// src/pages/modals/GroupDetailModal.jsx
import React from 'react';

export default function GroupDetailModal({ application, onClose, locale }) {
  if (!application) return null;

  const labelStyle = {
    fontWeight: '600',
    padding: '0.5rem',
    backgroundColor: '#f1f1f1',
    border: '1px solid #ddd',
    width: '30%',
  };

  const valueStyle = {
    padding: '0.5rem',
    border: '1px solid #ddd',
    width: '70%',
  };

  const rowStyle = {
    display: 'flex',
    flexDirection: 'row',
  };

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed',
        top: 0, left: 0,
        width: '100%', height: '100%',
        backgroundColor: 'rgba(0,0,0,0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: '#fff',
          padding: '2rem',
          borderRadius: '10px',
          width: '800px',
          maxWidth: '90%',
          maxHeight: '90vh',
          overflowY: 'auto',
          position: 'relative',
        }}
      >
        {/* Кнопка закрытия */}
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '10px',
            right: '10px',
            backgroundColor: 'transparent',
            color: '#000',
            border: 'none',
            borderRadius: '50%',
            width: '36px',
            height: '36px',
            fontSize: '1.5rem',
            fontWeight: 'bold',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          ×
        </button>

        {/* Заголовок */}
        <h2 style={{ textAlign: 'center', marginBottom: '1.5rem' }}>{application.title}</h2>

        {/* Таблица */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0px', border: '1px solid #ccc', borderRadius: '8px', overflow: 'hidden' }}>
          <div style={rowStyle}>
            <div style={labelStyle}>{locale === 'kz' ? 'Пән' : 'Предмет'}</div>
            <div style={valueStyle}>{locale === 'kz' ? application.subject?.name_kz : application.subject?.name_ru}</div>
          </div>
          <div style={rowStyle}>
            <div style={labelStyle}>{locale === 'kz' ? 'Сынып' : 'Класс'}</div>
            <div style={valueStyle}>{locale === 'kz' ? application.grade?.name_kz : application.grade?.name_ru}</div>
          </div>
          <div style={rowStyle}>
            <div style={labelStyle}>{locale === 'kz' ? 'Санат' : 'Категория'}</div>
            <div style={valueStyle}>{locale === 'kz' ? application.category?.name_kz : application.category?.name_ru}</div>
          </div>
          <div style={rowStyle}>
            <div style={labelStyle}>{locale === 'kz' ? 'Беттер саны' : 'Количество страниц'}</div>
            <div style={valueStyle}>{application.page_count}</div>
          </div>

          {application.final_document && (
            <div style={rowStyle}>
              <div style={labelStyle}>{locale === 'kz' ? 'Орташа балл' : 'Средняя оценка'}</div>
              <div style={valueStyle}>
                {application.final_document.average_score} ({application.final_document.status})
              </div>
            </div>
          )}
        </div>

        {/* Пустое пространство снизу */}
        <div style={{ height: '60px' }} />
      </div>
    </div>
  );
}
